import React from 'react';
import { useState } from "react";
import { DatePicker } from '@mui/x-date-pickers';

function YearMonthPicker({ handleChangeTo, value, fullWidth = true }) {
    const [selectedDate, handleDateChange] = useState(value || new Date());

    React.useEffect(() => {
        if (value) handleDateChange(value);
    }, [value]);

    return (
        <div className="picker">
            <DatePicker
                openTo="year"
                views={["year", "month"]}
                label="Mês e Ano"
                minDate={new Date("2015-01-01")}
                maxDate={new Date()}
                value={selectedDate}
                slotProps={{
                    textField: fullWidth
                        ? { fullWidth: true }
                        // No inline: preenche toda a largura no celular (xs) e usa
                        // a largura do conteúdo no desktop (md+).
                        : { sx: { width: { xs: '100%', md: 'auto' }, minWidth: { md: 170 } } },
                }}
                onChange={val => {
                    handleDateChange(val);
                    handleChangeTo(val);
                }}
            />
        </div>
    );
}

export default YearMonthPicker;